import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const UsernameField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item
      label="Username"
      name={SCRAPER_REQ_FIELD_KEY.USERNAME}
      required={required}
      rules={
        required ? [{ required: true, message: 'Username is required' }] : []
      }
    >
      <Input placeholder="Type username" sizeType="m" autoComplete="off" />
    </Form.Item>
  );
};
